export default __webpack_public_path__ + "static/media/light-imadev.a35b09f5.svg";